module.exports = ".separator {\n    margin: 0 0.618rem;\n}"